interface PostActionsProps {
    likes: number;
    onDataChange: (key: string, value: number) => void;
}

export default function PostActions({ likes, onDataChange }: PostActionsProps) {
    return (
        <div className="p-3">
            <button
                onClick={() => onDataChange("likes", likes + 1)}
                className="font-semibold"
            >
                {likes} likes
            </button>
        </div>
    );
}